import { Colors } from '@app/theme';
import { ExtendedParticipant, Participant } from '../participant';

export enum ParticipantFieldType {
  EMAIL = 'email',
  PHONE_NUMBER = 'phone',

  SINGLE_CHOICE = 'single_choice',
  MULTIPLE_CHOICE = 'multiple_choice',
  TAGS = 'tags',

  SHORT_TEXT = 'short_text',
  LONG_TEXT = 'long_text',
  DATE = 'date',
  NUMBER = 'number',

  GEOLOCATION = 'geolocation',
  INCOME = 'income',
  TIMEZONE = 'timezone',
  LOCALES = 'locales',

  BOOLEAN = 'boolean',
}

export enum ParticipantFieldCategory {
  PERSONAL = 'PERSONAL',
  DEMOGRAPHIC = 'DEMOGRAPHIC',
  GEOLOCATION = 'GEOLOCATION',
  DIGITAL_HABITS = 'DIGITAL_HABITS',
  PROFESSIONAL = 'PROFESSIONAL',
  MISC = 'MISC',
  STATS = 'STATS',
}

export enum ProfileFieldCategory {
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  PERSONAL = 'PERSONAL',
  PROFESSIONAL = 'PROFESSIONAL',
  OWNED_DEVICES = 'OWNED_DEVICES',
  OTHERS = 'OTHERS',
}

export interface ParticipantFieldCategoryConfig {
  name: ParticipantFieldCategory;
  icon: string;
  iconColor: Colors;
  title: string;
  titleClient?: string;
  description?: string;
}

export interface ParticipantFieldChoice {
  value: string | number;
  label: string;
}

export interface ExtendedParticipantField {
  name: keyof ExtendedParticipant;
  label: string;
  placeholder?: string;
  category: ParticipantFieldCategory;

  required?: boolean;
  type: ParticipantFieldType;
  choices?: ParticipantFieldChoice[];
  displayAsAge?: boolean;
  readOnly?: boolean;

  labelVariants?: {
    [key: string]: string;
  };
  criterion?: {
    aliases?: string[];
    disabled?: boolean;
    description?: string;
    locked?: boolean;
  };
  csv?: {
    columnAliases?: string[];
    guide?: string;
  };
  validation?: {
    min?: number;
    max?: number;
  };
  range?: {
    label?: string;
    step: number;
    min?: number;
    max?: number;
  };
  table?: {
    Cell?: string;
    filter?: string;
    singleLine?: boolean;
    useArrayFilter?: boolean;
    backupKey?: string;
  };
  profile?: {
    hidden?: boolean;
  };
  customForm?: {
    required?: boolean;
    available?: boolean;
  };
}

export interface ParticipantField extends ExtendedParticipantField {
  name: keyof Participant;
  profileCategory: ProfileFieldCategory;
}
